import { stripePriceId } from './StripeStore';

export const updateStripePriceId = (value) => stripePriceId.update(oldValue => value);
